import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import ElementUI from 'element-ui';
import store from './vuex/store'  // 全局数据
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import '../static/css/theme-green/index.css';       // 浅绿色主题
// import './components/common/directives';
import './assets/css/icon.css';
import "babel-polyfill";

import './utils/permission' // 权限

import VueQuillEditor  from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/css/global.css'
import less from 'less'
Vue.use(less)

Vue.use(VueQuillEditor);

Vue.config.productionTip = true
Vue.use(ElementUI, {
    size: 'small'
});
Vue.prototype.$axios = axios;

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')